
import firebase from "firebase/compat/app";
import 'firebase/compat/database';
import "firebase/compat/auth";
const firebaseConfig = {
  apiKey: "AIzaSyBQGcQ5crL4mxZU0H5IZt8hVnnJM0JWdEU",
  authDomain: "express-vr-bb948.firebaseapp.com",
  databaseURL: "https://express-vr-bb948-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "express-vr-bb948",
  storageBucket: "express-vr-bb948.appspot.com",
  messagingSenderId: "1001283934372",
  appId: "1:1001283934372:web:cc9a355a43339bc113ae31",
  measurementId: "G-CYJDYBVN5N"
  };

firebase.initializeApp(firebaseConfig);
export const dataRef=firebase.database();
export default firebase;